<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UiFormItem from './UIFormItem';

@Component({
  inheritAttrs: false,
  props: {
    value: {},
    instructions: {},
    ...UiFormItem.options.props,
  },
})
export default class UIRadio extends Vue {

}
</script>

<template lang="pug">
label.ui-radio.f8(:class="{ '-active': value }")
  input.input(type='radio', v-bind="$attrs", :value="value", :checked="value", v-on="$listeners", @change="$emit('input', $attrs.value)")
  slot
    span {{ title }}
  span.instructions {{ instructions }}

</template>

<style scoped lang="postcss">
@import "../../styles";
.ui-radio {
  font-family: var(--fontSansSerif);
  & .input {
    margin-right: 1rem;
  }

  & .instructions {
    @apply --f7;
    display: block;
    margin-left: 2rem;
  }
}
</style>
